import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    applyFilterByMainKeyAndSlug,
    clearAllFilter,
    clearFilterByKeyAndSelectionIndex
} from "../../../../store/slice/ProductListingFilterApplied";
import Product from "@system/config/product";
import $ from "jquery";
import System from "src/helper/system";
import { isObject } from "underscore";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';

const ProductDetailDescriptionTab = (props) => {
    const dispatch = useDispatch();
    const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    const [productData, setProductData] = useState([]);
    const [ECCNData, setECCNData] = useState([]);
    const [ascDesField, setAscDesField] = useState({});
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    const inventory = inventoryList;
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const filter = useSelector((state) => state.entities.ProductListingFilterApplied)

    const setFilterBoxForField = (element) => {
        let d = getAppliedFilterStatusByValue(element.ATTRNAME, element.ATTRVAL);
        if (!d) {
            applyFilterByMainKeyAndSlugInternal(element);
        } else {
            dispatch(clearFilterByKeyAndSelectionIndex({
                key: System.anythingToCamel(element.ATTRNAME),
                selectionIndex: d.i,
            }))
        }
    };

    const getAppliedFilterStatusByValue = (name, value) => {
        let slug = System.anythingToCamel(name);
        if (filter[slug] && filter[slug].selection &&
            filter[slug].selection.length
        ) {
            let decision = false;
            filter[slug].selection.map((v, i) => {
                if (v.value === value) {
                    decision = {
                        v, i
                    };
                }
            })
            return decision;
        }
        return false;
    };

    const applyFilterByMainKeyAndSlugInternal = (element) => {
        dispatch(applyFilterByMainKeyAndSlug({
            key: System.anythingToCamel(element.ATTRNAME),
            main_label: element.ATTRNAME,
            value: element.ATTRVAL,
        }))
    }
    const toggleAllSelection = () => {
        let status = !getMainSelectionStatus();
        if (status) {
            if (productDetail.value.Attributes.length) {
                productDetail.value.Attributes.map((v) => {
                    applyFilterByMainKeyAndSlugInternal(v);
                });
            }
        } else {
            dispatch(clearAllFilter())
        }
    };
    const getMainSelectionStatus = () => {
        let activeFilterCount = 0;
        let productDetailCount = false;

        if (productDetail?.value?.Attributes &&
            productDetail.value.Attributes.length > 0) {
            productDetailCount = productDetail.value.Attributes.length;
            productDetail.value.Attributes.map((v) => {
                if (getAppliedFilterStatusByValue(v.ATTRNAME, v.ATTRVAL)) {
                    activeFilterCount++;
                }
            });
        }
        if (activeFilterCount === productDetailCount) {
            return true;
        }
        return false;
    };
    const goToProductListing = () => {
        window.location.href = Product.getProductListingPageRouteURL() + '?' + $.param({
            go: System.getParams().go,
            appendFacadeOptions: 'yes'
        });
    };

    useEffect(() => {
        if (productDetail?.value?.Attributes && productDetail.value.Attributes.length > 0) {
            setProductData(productDetail.value.Attributes)
        }

        if (productDetail?.value) {
            let ECCNInfo = [];
            if (productDetail.value?.sap_originating_countryoforigin) {
                const ECCNObj = {
                    Name: "Country of Origin",
                    Value: productDetail.value.sap_originating_countryoforigin
                };
                ECCNInfo.push(ECCNObj);
            }

            if (productDetail.value.ECCNCode && productDetail.value.ECCNCode.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'ECCN'
                ECCNObj.Value = productDetail.value.ECCNCode
                ECCNInfo.push(ECCNObj)
            }

            if (productDetail.value.HTSCode && productDetail.value.HTSCode.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'COMMODITY CODE'
                ECCNObj.Value = productDetail.value.HTSCode
                ECCNInfo.push(ECCNObj)
            }

            if (productDetail.value.UNSPSC && productDetail.value.UNSPSC.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'UNSPSC'
                ECCNObj.Value = productDetail.value.UNSPSC
                ECCNInfo.push(ECCNObj)
            }

            if (productDetail.value.UNSPSCVersion && productDetail.value.UNSPSCVersion.trim()) {
                let ECCNObj = {};
                ECCNObj.Name = 'UNSPSC VERSION'
                ECCNObj.Value = productDetail.value.UNSPSCVersion
                ECCNInfo.push(ECCNObj)
            }

            setECCNData(ECCNInfo)
        }


    }, [productDetail]);

    const sortAttributes = (columnName) => {
        let Attributes = (columnName === 'Name' || columnName === 'Value') ? [...ECCNData] : [...productData]
        let AttributesSorted = []
        if (ascDesField.hasOwnProperty(columnName)) {
            ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setAscDesField(ascDesField)
        } else {
            ascDesField[columnName] = 'ASC'
            setAscDesField(ascDesField)
        }
        setSortBy(columnName)
        setSortOrder(ascDesField[columnName])
        if (ascDesField[columnName] === 'ASC') {
            AttributesSorted = Attributes.sort((a, b) => (b[columnName] < a[columnName] ? -1 : 1));
        } else if (ascDesField[columnName] === 'DESC') {
            AttributesSorted = Attributes.sort((a, b) => (b[columnName] > a[columnName] ? -1 : 1));
        }
        //Working Not working, Will continue.
        if (columnName === 'Name' || columnName === 'Value') {
            setECCNData(AttributesSorted)
        } else {
            setProductData(AttributesSorted)
        }
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    //By Ramya Kannan [Product view - Adobe script ]

    const [isProdViewEvent, setProdViewEvent] = useState(true)
    useEffect(() => {
        let checkCon = productDetail?.value && isProdViewEvent && Object.keys(inventory).length && System.checkPriceValues(pricingList);
        if (checkCon) {
            prodViewEvent();
            setProdViewEvent(false)
        }
    }, [productDetail, inventory, pricingList])


    function prodViewEvent() {
        localStorage.setItem("adobeEventType", "productViewEvent");
        let prodDetails = { ...productDetail?.value };
        prodDetails.qas = getInventory(prodDetails?.ERPPartNumber)?.qas;
        prodDetails.priceSource = getPricing(
            prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
            prodDetails.ERPPartNumber,
            prodDetails.ERPPartNumberModified
        )[0]?.priceSource;

        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
        }
    }


    //added by Ramya [Adobe script]
    const getInventory = (ERPPartNumber) => {
        if (inventory[ERPPartNumber] !== undefined) {
            return inventory[ERPPartNumber];
        }
        return {
            qas: 0,
            quantity: 0,
        };
    };
    const getPricing = (
        ERPMFRPartNumber,
        ERPPartNumber,
        ERPPartNumberModified
    ) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
            return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
    };



    return (
        <>
            <div className="tab-pane active" id="tab1">
                <div className="productdetail-description">
                    {(productDetail?.value?.LongDescription && productDetail.value.LongDescription.trim() !== '') ?
                        <p className="mob-font-13 mb-2"
                            dangerouslySetInnerHTML={{ __html: productDetail.value.LongDescription }}></p> : ''}

                    {(productDetail?.value?.ProductFeatures && productDetail.value.ProductFeatures.trim() !== '') ?
                        <p className="mob-font-13 mb-2"
                            dangerouslySetInnerHTML={{ __html: productDetail.value.ProductFeatures }}></p> : ''}
                </div>

                {productData && productData.length > 0 &&
                    <div>
                        <h4 className="mb-2 mt-0">Technical Attributes</h4>
                        <p className="text-sm">Find Similar Parts</p>
                        {productDetail?.value?.Attributes &&
                            productDetail.value.Attributes.length > 0 ?
                            <div className='table-responsive'>
                                <table className="bs5 table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="w35 font-12">
                                                <div className="form-check d-flex align-items-center font-18">
                                                    <input type="checkbox" className="form-check-input  me-1"
                                                        id="productDetailAttribute"
                                                        checked={getMainSelectionStatus()}
                                                        onChange={() => {
                                                            toggleAllSelection()
                                                        }}
                                                    />
                                                    <label className="form-check-label"
                                                        htmlFor="productDetailAttribute" />
                                                </div>
                                            </th>
                                            <th><span>Description</span>
                                                <span
                                                    className={'sort-container ' +
                                                        getOrderByClass('ATTRNAME')
                                                    }
                                                    onClick={() => {
                                                        sortAttributes('ATTRNAME')
                                                    }}
                                                ></span>
                                            </th>
                                            <th><span>Value</span>
                                                <span className={'sort-container ' +
                                                    getOrderByClass('ATTRVAL')
                                                }
                                                    onClick={() => {
                                                        sortAttributes('ATTRVAL')
                                                    }}></span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productData.map((element, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="form-check d-flex align-items-center font-18">
                                                        <input type="checkbox" className="form-check-input  me-1"
                                                            id={index + 'Row_Filter'}
                                                            checked={getAppliedFilterStatusByValue(element.ATTRNAME, element.ATTRVAL)}
                                                            onChange={(e) => {
                                                                setFilterBoxForField(element, e.target.checked)
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className="form-check-label"
                                                        htmlFor={index + 'Row_Filter'}>{element.ATTRNAME  && element.ATTRNAME.trim() !== '' ? element.ATTRNAME : '-'}</label>
                                                </td>
                                                <td>{element.ATTRVAL && element.ATTRVAL.trim() !== '' ? element.ATTRVAL : '-'}</td>
                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                </table>
                            </div> : ''
                        }
                        <button
                            disabled={!(isObject(filter) && Object.entries(filter).length > 0)}
                            onClick={() => {
                                goToProductListing()
                            }}
                            className={(!(isObject(filter) && Object.entries(filter).length > 0)) ? 'bs5 btn btn-secondary mt-2 mb-4 disabled' : 'bs5 btn btn-secondary mt-2 mb-4'}>find
                            similar parts
                        </button>
                    </div>
                }

                <div className="mt-1">
                    {ECCNData  && ECCNData.length > 0 &&
                        <>
                            <h4 className="mb-3 mt-0"> ECCN/Commodity Code</h4>
                            <div className='table-respnsive'>
                                <table className="bs5 table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><span>Description</span>
                                                <span className={'sort-container ' +
                                                    getOrderByClass('Name')
                                                }
                                                    onClick={() => {
                                                        sortAttributes('Name')
                                                    }}></span>
                                            </th>
                                            <th><span>Value</span>
                                                <span className={'sort-container ' +
                                                    getOrderByClass('Value')
                                                }
                                                    onClick={() => {
                                                        sortAttributes('Value')
                                                    }}></span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            ECCNData.map((v, i) => (
                                                <tr key={i}>
                                                    <td>{v.Name}:</td>
                                                    <td>{v.Value}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </>
                    }

                </div>
            </div>
        </>
    );
}

export default ProductDetailDescriptionTab;